// extracted by mini-css-extract-plugin
export default {"item":"yearNumberRange_item__QXVJv","yearReport":"yearNumberRange_yearReport__QVFX6"};